import type { StateObservable } from 'redux-observable';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { merge } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import type { Action } from 'state/actions';
import type { AppState } from 'state/state.model';
import { getTabWorkspaceType } from 'state/workspaces/workspaces/workspaces.selector';

export function tabRemoved(actions$: Observable<Action>, tabId: string, state$: Observable<AppState>) {
  return merge(
    actions$.pipe(
      ofType('WORKSPACE_TAB_REMOVED'),
      filter(a => a.id === tabId),
    ),
    actions$.pipe(
      ofType('WORKSPACE_TABS_ALL_REMOVED'),
      withLatestFrom(state$),
      filter(([a, state]) => {
        const tabWorkspace = getTabWorkspaceType(state, tabId);
        // When ALL_REMOVED action had already been reduced before running the epic,
        // the workspace type will be undefined
        return tabWorkspace === undefined || a.workspace === tabWorkspace;
      }),
      map(([a]) => a),
    ),
  );
}

export function batchTabOrFormRemoved(
  actions$: Observable<Action>,
  tabId: string,
  formId: string,
  state$: StateObservable<AppState>,
) {
  return merge(
    actions$.pipe(
      ofType('WORKSPACE_TAB_REMOVED'),
      filter(a => a.id === tabId),
    ),
    actions$.pipe(
      ofType('BATCH_FORMS_DELETE_REQUESTED'),
      filter(a => a.formIds.includes(formId)),
    ),
    actions$.pipe(
      ofType('WORKSPACE_TABS_ALL_REMOVED'),
      withLatestFrom(state$),
      filter(([a, state]) => {
        const tabWorkspace = getTabWorkspaceType(state, tabId);
        return !!tabWorkspace && a.workspace === tabWorkspace;
      }),
      map(([a]) => a),
    ),
  );
}
